import { APIS } from "../../../../../utils/api-factory";
import { TENANT_POST_HEADER } from "../../../../../utils/apiHeaders";

export const getDisbursalData = (startDate, endDate,nbfc, callBack, onError) => {
  const url = `${APIS.GET_DISBURSAL_DATA}?startDate=${startDate}&endDate=${endDate}&nbfcId=${nbfc}`;
  fetch(url, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};

export const getCollectionData = (month, callBack, onError) => {
  const url = `${APIS.GET_COLLECTION_DATA}?month=${month}`;
  fetch(url, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};

export const getEmiBreakdown = (startDate, endDate,nbfc, callBack, onError) => {
  const url = `${APIS.GET_EMI_BREAKDOWN}?startDate=${startDate}&endDate=${endDate}&nbfcId=${nbfc}`;
  fetch(url, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getcollectionBreakdown = (startDate, endDate,nbfc, callBack, onError) => {
  const url = `${APIS.GET_COLLECTION_BREAKDOWN}?startDate=${startDate}&endDate=${endDate}&nbfcId=${nbfc}`;
  fetch(url, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};

export const getCollectionSummary = (startDate, endDate,nbfc, callBack, onError) => {
  const url = `${APIS.GET_COLLECTION_SUMMARY}?startDate=${startDate}&endDate=${endDate}&nbfcId=${nbfc}`;
  fetch(url, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};

export const getFunnel = (startDate, endDate,nbfc, callBack, onError) => {
  const url = `${APIS.GET_FUNNEL}?startDate=${startDate}&endDate=${endDate}&nbfcId=${nbfc}`;
  fetch(url, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};

export const getEmiBehavior = (startDate, endDate,nbfc, callBack, onError) => {
  const url = `${APIS.GET_EMI_BEHAVIOR}?startDate=${startDate}&endDate=${endDate}&nbfcId=${nbfc}`;
  fetch(url, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};

export const getProjection = (startDate, endDate, callBack, onError) => {
  const url = `${APIS.GET_PROJECTION}?startDate=${startDate}&endDate=${endDate}`;
  fetch(url, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};

export const getOverdueSummary = (startDate, endDate,nbfc, callBack, onError) => {
  const url = `${APIS.GET_OVERDUE_SUMMARY}?startDate=${startDate}&endDate=${endDate}&nbfcId=${nbfc}`;
  fetch(url, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};

export const getFinancialSummary = (month, callBack, onError) => {
  const url = `${APIS.GET_FINANCIAL_SUMMARY}?month=${month}`;
  fetch(url, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};

export const getAlertsData = (month, callBack, onError) => {
  const url = `${APIS.GET_ALERTS_DATA}?month=${month}`;
  fetch(url, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};

export const getFunnelStages = (month, callBack, onError) => {
  const url = `${APIS.GET_FUNNEL_STAGES}?month=${month}`;
  fetch(url, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};

export const getDropoffData = (month, callBack, onError) => {
  const url = `${APIS.GET_DROPOFF_DATA}?month=${month}`;
  fetch(url, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getEmiBreakDownListData = (startDate, endDate, monthName, emiStatus, page, size,nbfc, callBack, onError) => {
  const url = `${APIS.GET_EMI_REAKDOWN_LEAD_LIST_DATA + startDate}&endDate=${endDate}&monthName=${monthName}&emiStatus=${emiStatus}&page=${page}&size=${size}&nbfcId=${nbfc}`;
  fetch(url, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getCollectionBreakDownListData = (startDate, endDate, monthName, emiStatus, page, size,nbfc, callBack, onError) => {
  const url = `${APIS.GET_COLLECTION_REAKDOWN_LEAD_LIST_DATA + startDate}&endDate=${endDate}&monthName=${monthName}&emiStatus=${emiStatus}&page=${page}&size=${size}&nbfcId=${nbfc}`;
  fetch(url, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};



export const DownloadEmiBreakdownLeadListData = (
  startDate, endDate, month,nbfc,
  callBack
) => {

  fetch(APIS.DOWNLOAD_EMI_REAKDOWN_LEAD_LIST_DATA + startDate + "&endDate=" + endDate + "&monthName=" + month + "&nbfcId=" + nbfc, {
    method: 'GET'
  })
    .then(res => res.blob())
    .then(data => {
      var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      var excelBlob = new Blob(
        [data],
        { type: 'application/vnd.ms-excel' },
        'excel.xls'
      )

      var downloadUrl = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = downloadUrl
      a.download = 'EMI_Breakdown_Leads.xls'
      document.body.appendChild(a)
      a.click()
      callBack(data)
    })
}
export const DownloadCollectionBreakdownLeadListData = (
  startDate, endDate, month,nbfc,
  callBack
) => {

  fetch(APIS.DOWNLOAD_COLLECTION_REAKDOWN_LEAD_LIST_DATA + startDate + "&endDate=" + endDate + "&monthName=" + month + "&nbfcId=" + nbfc, {
    method: 'GET'
  })
    .then(res => res.blob())
    .then(data => {
      var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      var excelBlob = new Blob(
        [data],
        { type: 'application/vnd.ms-excel' },
        'excel.xls'
      )

      var downloadUrl = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = downloadUrl
      a.download = 'EMI_Breakdown_Leads.xls'
      document.body.appendChild(a)
      a.click()
      callBack(data)
    })
}

// Nach management apis

export const getOverviewNachDataByFilters = (startDate, endDate, gateway, callBack, onError) => {

  fetch(APIS.GET_OVERVIEW_NACH_DATA_BY_FILTERS + startDate + "&endDate=" + endDate + "&gateway=" + gateway,
    { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getNachListDataByMultiFilters = (search, fromDate, toDate, retryCountMin, medium, status, page, size, callBack, onError) => {

  fetch(APIS.GET_NACH_LIST_BY_MULTI_FILTERS + search + "&fromDate=" + fromDate + "&toDate=" + toDate + "&retryCount=" + retryCountMin + "&medium=" + medium + "&status=" + status + "&page=" + page + "&size=" + size,
    { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getFailureReasonListForGraph = (fromDate, toDate, medium, callBack, onError) => {

  fetch(APIS.GET_FAILURE_REASON_LIST_FOR_GRAPH + fromDate + "&toDate=" + toDate + "&medium=" + medium,
    { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getBankFailureReasonListForGraph = (fromDate, toDate, medium, callBack, onError) => {

  fetch(APIS.GET_BANK_FAILURE_REASON_LIST_FOR_GRAPH + fromDate + "&toDate=" + toDate + "&medium=" + medium,
    { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getRetrySuccessRateForGraph = (fromDate, toDate, medium, callBack, onError) => {

  fetch(APIS.GET_RETRY_SUCESS_RATE_FOR_GRAPH + fromDate + "&toDate=" + toDate + "&medium=" + medium,
    { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getDailyTrendRangeFromFilters = (fromDate, toDate, medium, callBack, onError) => {

  fetch(APIS.GET_DAILY_TREND_RANGE_FROM_FILTERS + fromDate + "&toDate=" + toDate + "&gateway=" + medium,
    { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getActivePaymentGatewayService = (callBack, onError) => {

  fetch(APIS.GET_ACTIVE_GATEWAY_SERVICE_LIST,
    { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const downloadNachactiveApi = (
  fromDate,
  toDate,
  status,
  gateway,
  callBack,
  onError
) => {
  fetch(
    APIS.DOWNLOAD_NACH_EXPORT_API_FROM_FILTERS +
    fromDate +
    "&toDate=" +
    toDate +
    "&status=" +
    status +
    "&gateway=" +
    gateway,
    { headers: TENANT_POST_HEADER }
  )
    .then((res) => {
      if (!res.ok) throw new Error("Download failed");
      return res.blob();
    })
    .then((blob) => {
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      // You can customize file name
      a.download = `Nach_${fromDate}_to_${toDate}.xlsx`;

      document.body.appendChild(a);
      a.click();

      // Cleanup
      a.remove();
      window.URL.revokeObjectURL(url);

      callBack && callBack(true);
    })
    .catch((e) => {
      onError && onError(e);
    });
};
export const downloadScheduleNachactiveApi = (
  fromDate,
  toDate,
  status,
  gateway,
  callBack,
  onError
) => {
  fetch(
    APIS.DOWNLOAD_NACH_SCHEDULE_EXPORT_API_FROM_FILTERS +
    fromDate +
    "&toDate=" +
    toDate +
    "&status=" +
    status +
    "&gateway=" +
    gateway,
    { headers: TENANT_POST_HEADER }
  )
    .then((res) => {
      if (!res.ok) throw new Error("Download failed");
      return res.blob();
    })
    .then((blob) => {
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      // You can customize file name
      a.download = `Scheduled_Nach_${fromDate}_to_${toDate}.xlsx`;

      document.body.appendChild(a);
      a.click();

      // Cleanup
      a.remove();
      window.URL.revokeObjectURL(url);

      callBack && callBack(true);
    })
    .catch((e) => {
      onError && onError(e);
    });
};

export const getNachOverviewScheduleByFilters = (startDate,endDate,gateway,callBack, onError) => {

  fetch(APIS.GET_NACH_OVERVIEW_SCHEDULE_BY_FILTERS + startDate + "&endDate=" + endDate + "&gateway=" + gateway,
    { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      callBack("")
      onError(e);
    });
};
export const getNachScheduleUpcomingByLimit = (limit,callBack, onError) => {

  fetch(APIS.GET_NACH_SCHEDULE_UPCOMING_BY_LIMIT + limit,
    { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      callBack("")
      onError(e);
    });
};
export const getForecastVolumeByFilters = (sDate,endDate,gateway,callBack, onError) => {

  fetch(APIS.GET_FORECAST_VOLUME_BY_FILTERS_DATE + sDate + "&endDate=" + endDate + "&gateway="+ gateway, 
    { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      callBack("")
      onError(e);
    });
};
export const getCollectionVolumeByFilters = (sDate,endDate,gateway,callBack, onError) => {

  fetch(APIS.GET_COLLECTION_VOLUME_BY_FILTERS_DATE + sDate + "&endDate=" + endDate + "&gateway="+ gateway, 
    { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      callBack("")
      onError(e);
    });
};
export const getForecastRiskAssessmentByFilters = (sDate,endDate,gateway,callBack, onError) => {

  fetch(APIS.GET_FORECAST_RISK_ASSESSMENT_BY_FILTERS_DATE + sDate + "&endDate=" + endDate + "&gateway="+ gateway, 
    { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      callBack("")
      onError(e);
    });
};
export const getForecastInsightsByFilters = (sDate,endDate,gateway,callBack, onError) => {

  fetch(APIS.GET_FORECAST_INSIGHTS_BY_FILTERS_DATE + sDate + "&endDate=" + endDate + "&gateway="+ gateway, 
    { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      callBack("")
      onError(e);
    });
};
export const getScheduleNachListByFilters = (search,sDate,endDate,gateway,retryCountMin,status,page,size,callBack, onError) => {

  fetch(APIS.GET_SCHEDULE_NACH_LIST_BY_FILTERS_DATE + sDate + "&endDate=" + endDate + "&gateway="+ gateway + "&search=" + search + 
    "&retryCount=" + retryCountMin  + "&status=" + status + "&page=" + page + "&size=" + size,  
    { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      callBack("")
      onError(e);
    });
};
export const getAlertsListByFiltersDate = (sDate,endDate, gateway,callBack, onError) => {

  fetch(APIS.GET_ALERTS_LIST_BY_FILTERS_DATE + sDate + "&endDate=" + endDate + "&gateway="+ gateway ,  
    { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      callBack("")
      onError(e);
    });
};
export const deactivateNachForActiveService = (userId,service, deactivatedBy,callBack, onError) => {

  fetch(APIS.DEACTIVATE_ENACH_FOR_ACTIVE_SERVICES + userId + "&service=" + service + "&deactivatedBy="+  deactivatedBy,  
    { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      callBack("")
      onError(e);
    });
};